<div mat-dialog-content>
  <div *ngFor="let update of data">
    <h4>Update: {{update[0]}}</h4>
    <ul>
      <li *ngFor="let entry of update | slice:1">{{entry}}</li>
    </ul>
  </div>

  <button color="primary" mat-stroked-button mat-dialog-close>Close</button>
</div>

